import { CreditCardBox } from '@apply/components';
import creditCardType from 'credit-card-type';
import { CardFocusType } from '../../../../../constants/CardFocusType';
import { useEffect } from 'react';
import { CardType } from '../../../../../constants/CardType';
import {
    useCustomPaymentCardFocus,
    useCustomPaymentCardNumber,
    useCustomPaymentCardType,
} from '../../../../../fields/CustomPaymentFields';

interface CardNumberParameters {
    customPaymentId: string;
    disabled: boolean;
}

export const CardNumber: React.FC<CardNumberParameters> = ({ customPaymentId, disabled }) => {
    const [cardNumber, set_cardNumber] = useCustomPaymentCardNumber(customPaymentId);
    const [, set_cardFocus] = useCustomPaymentCardFocus(customPaymentId);
    const [, set_cardType] = useCustomPaymentCardType(customPaymentId);

    useEffect(() => {
        let cardType: CardType | undefined = undefined;

        if (!cardNumber) {
            set_cardType(undefined);
            return;
        }

        const numbersOnly = cardNumber.replace(/[ _]/g, '');
        const cardTypes = creditCardType(numbersOnly);

        if (cardTypes.length === 1) {
            cardType = cardTypes[0].niceType.toUpperCase() as CardType | undefined;
        }

        set_cardType(cardType);
    }, [cardNumber]);

    return (
        <CreditCardBox
            label='Card Number'
            name='card-number'
            value={cardNumber}
            onChange={(value) => set_cardNumber(value)}
            onFocusIn={() => set_cardFocus(CardFocusType.CardNumber)}
            disabled={disabled}
        />
    );
};
